var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoGalleryVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4a4e032b-539e-496d-9978-87d9097c1de0",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-6f9e7234-ebca-48a1-83e5-6a571ac4cc23",
    x1: 25.87,
    y1: 107.04,
    x2: 83.87,
    y2: 49.04,
    gradientTransform: "translate(0 105) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-8f30cddb-eb68-435e-abf7-64c7d761ee51",
    x1: 21.21,
    y1: 97.7,
    x2: 90.87,
    y2: 28.04,
    xlinkHref: "#uuid-6f9e7234-ebca-48a1-83e5-6a571ac4cc23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f923c6c3-4a8d-43da-842f-fb25205d8c8b",
    x1: 28.09,
    y1: 42.09,
    x2: 62.91,
    y2: 76.91,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#uuid-6f9e7234-ebca-48a1-83e5-6a571ac4cc23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.5,63.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-6f9e7234-ebca-48a1-83e5-6a571ac4cc23)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5,70.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-8f30cddb-eb68-435e-abf7-64c7d761ee51)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,41.5H29.5c-1.1,0-2,.9-2,2v32c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-32c0-1.1-.9-2-2-2Zm-10.32,18.87l-10.36,5.98c-.67.38-1.5-.1-1.5-.87v-11.96c0-.77.83-1.25,1.5-.87l10.36,5.98c.67.38.67,1.35,0,1.73Z",
    fill: "url(#uuid-f923c6c3-4a8d-43da-842f-fb25205d8c8b)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoGalleryVideos);
export default __webpack_public_path__ + "static/media/expo_gallery_videos.9a85564fda545d1fe37150439c999aa1.svg";
export { ForwardRef as ReactComponent };